var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._b({class:{ 'pa-0': _vm.fluid },style:(_vm.fluid ? '' : ("max-width: " + _vm.maxWidth + "px !important;")),attrs:{"fluid":_vm.fluid}},'v-container',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }